import { render, staticRenderFns } from "./FeatureSectionArticles.vue?vue&type=template&id=3a1604a0"
import script from "./FeatureSectionArticles.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureSectionArticles.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports